// Factura indexada a BCV (#151): mismo cálculo que
// backend/src/utils/indexacion.js. La factura es en Bs; su base (total)
// se paga a la tasa BCV del día del pago y el IVA y las retenciones quedan
// fijos en Bs. El saldo se lleva en Bs de emisión; esto convierte.
// `f` necesita total, monto_adeudado y tasa_bcv (la de emisión).

const round2 = (n) => Math.round(Number(n) * 100) / 100;
const pos = (n) => (Number(n) > 0 ? Number(n) : null);

export const esIndexada = (f) => !!Number(f?.indexada) && f?.moneda === 'BS';

function partesIndexada(f, pagado) {
  const total = Number(f.total) || 0;
  const fijo = round2((Number(f.monto_adeudado) || 0) - total);
  const pag = Number(pagado) || 0;
  const te = pos(f.tasa_bcv);
  if (fijo >= 0) {
    return {
      te,
      idx: Math.max(round2(total - pag), 0),
      fijo: Math.max(round2(fijo - Math.max(pag - total, 0)), 0),
      credito: 0
    };
  }
  const credito = -fijo;
  if (pag <= 0.005) return { te, idx: total, fijo: 0, credito };
  return { te, idx: Math.max(round2(total - pag - credito), 0), fijo: 0, credito: 0 };
}

// Lo que se debe en Bs con la BCV `bcv`.
export function saldoIndexadoBs(f, pagado, bcv) {
  const p = partesIndexada(f, pagado);
  const b = pos(bcv);
  const r = p.te && b ? b / p.te : 1;
  return Math.max(round2(p.idx * r + p.fijo - p.credito), 0);
}

// Un pago de `montoBs` con BCV `bcv` -> Bs de emisión que baja del saldo.
export function pagoIndexadoAFactura(f, pagadoPrevio, montoBs, bcv) {
  const p = partesIndexada(f, pagadoPrevio);
  const b = pos(bcv);
  if (!p.te || !b) return null;
  const r = b / p.te;
  const x = (Number(montoBs) || 0) + p.credito;
  const idxHoy = p.idx * r;
  const cubre = x <= idxHoy + 0.005 ? x / r : p.idx + (x - idxHoy);
  return round2(cubre - p.credito);
}

// Saldo de una factura en la vista pedida (USD/BCV/BS). Para una indexada
// que viene del servidor con `indexacion`, es lo que se debe HOY.
export function saldoEnVista(f, vista, aVista) {
  if (f.indexacion) {
    return aVista(f.indexacion.saldo_hoy_bs, vista, 'BS', f.indexacion.bcv_hoy, f.indexacion.mercado_hoy);
  }
  return aVista(f.saldo, vista, f.moneda, f.tasa_bcv, f.tasa_mercado);
}
